import React, { useCallback, useMemo } from "react";
import { IconButton, MenuItem, ButtonBase } from "@material-ui/core";
import { connect, useSelector } from "react-redux";
import PageBox from "../../../components/PageBox/PageBox.component";
import styles from "./Style.module.css";
import DataTables from "../../../Datatables/Datatable.table";
import Constants from "../../../config/constants";
import CustomSelectField from "../../../components/FormFields/SelectField/SelectField.component";
import useIncentiveRulesHook from "./IncentiveRules.hook";

const conditionsConfig = [
  // {
  //   label: "Early Bird: Subsequent Month Target Met (%)",
  //   key: "early_bird_target_met_value",
  // },
  {
    label: "Rupee value: Next Qtr 1st Month Target Met (%)",
    key: "rupee_value_next_qtr_first_month_target_met_value",
  },
  {
    label: "Rupee value: Min Product Incentive Criteria Met (%)",
    key: "rupee_value_min_product_criteria_met_value",
  },
  {
    label: "Product: Next Qtr 1st Month Target Met (%)",
    key: "product_next_qtr_first_month_target_met_value",
  },
  {
    label: "Payment Collection Realized (%)",
    key: "payment_collection_realized_value",
  },
  {
    label: "MCL Coverage Min %",
    key: "mcl_coverage_value",
  },
];

const IncentiveRules = ({}) => {
  const { form, changeTextData, listData, handleDetail, data } =
    useIncentiveRulesHook({});

  const renderDropDown = useMemo(() => {
    return (
      <CustomSelectField
        label={"Marketing Year"}
        value={form?.fy_year}
        handleChange={(value) => {
          changeTextData(value, "fy_year");
        }}
      >
        {listData?.FY_YEAR?.map((val, index) => (
          <MenuItem key={index} value={val?.value}>
            {val?.label}
          </MenuItem>
        ))}
      </CustomSelectField>
    );
  }, [form?.fy_year, listData?.FY_YEAR]);

  const renderDropDownType = useMemo(() => {
    return (
      <CustomSelectField
        label={"Quarter"}
        value={form?.quarter}
        handleChange={(value) => {
          changeTextData(value, "quarter");
        }}
      >
        <MenuItem value="Q1">Q1</MenuItem>
        <MenuItem value="Q2">Q2</MenuItem>
        <MenuItem value="Q3">Q3</MenuItem>
        <MenuItem value="Q4">Q4</MenuItem>
      </CustomSelectField>
    );
  }, [form?.quarter]);

  return (
    <div>
      <PageBox>
        <div className={styles.headerContainer}>
          <div>
            <span className={styles.title}>Incentive Rules</span>
            <div className={styles.newLine} />
          </div>
        </div>

        <div className={styles.yearFlex}>
          <div className={styles.down}>{renderDropDown}</div>
          <div className={styles.down}>{renderDropDownType}</div>
          <div className={styles.btnCont}>
            <ButtonBase
              // disabled={downloading}
              onClick={handleDetail}
              className={"createBtn"}
              // id={styles.btnHideResponsive}
            >
              MANAGE RULES
            </ButtonBase>
          </div>
          <div className={styles.lastWrap}>
            <div className={styles.value}>Last Modified:</div>
            {data?.updatedAt}
          </div>
        </div>
      </PageBox>
      <br />

      <div className={styles.plainPaper}>
        <div className={styles.heading}>Early Bird Incentive</div>

        <div className={styles.commentContainer}>
          <div className={styles.otherWrap}>
            <div className={styles.flexRow}>
              <div className={styles.left}>
                Early Bird: Calculation Month Target Met (%)
              </div>
              <div className={styles.right}>
                {data?.early_bird_target_met_value ?? 0}
              </div>
            </div>

            <div className={styles.flexRow}>
              <div className={styles.left}>
                Early Bird: Subsequent Month Target Met (%)
              </div>
              <div className={styles.right}>
                {data?.early_bird_subsequent_target_met_value ?? 0}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.plainPaper}>
        <div className={styles.heading}>Product + Rupee Target Rules.</div>

        <div className={styles.commentContainer}>
          <div className={styles.otherWrap}>
            <div className={styles.flexRow}>
              <div className={styles.left}>
                TBM Level Target Achievement (%)
              </div>
              <div className={styles.right}>{data?.tbm_achievement_prct ?? 0}</div>
            </div>

            <div className={styles.flexRow}>
              <div className={styles.left}>
                Manager Level Target Achievement (%)
              </div>
              <div className={styles.right}>
                {data?.manager_achievement_prct ?? 0}
              </div>
            </div>

            <div className={styles.flexRow}>
              <div className={styles.left}>
                Other brand achievement %age for SPI
              </div>
              <div className={styles.right}>
                {data?.spi_other_achievement_prct ?? 0}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.plainPaper}>
        <div className={styles.newContainer}>
          <div className={styles.heading}>Product Incentive</div>
          <div className={styles.commentContainer}>
            <div className={styles.otherWrap}>
              <div className={styles.mainFlex}>
                <div className={styles.left}>
                  <div className={styles.key}>
                    <span className={styles.value}>Max Achieved Families:</span>
                    {data?.max_achieved_families}
                  </div>
                </div>
                <div className={styles.right}>
  <div className={styles.key}>
    <span className={styles.value}>
      Special product Incentive Achievement %:
    </span>
    <span className={styles.dataValue}>
      {data?.spi_other_achievement_prct}
    </span>
  </div>
</div>
              </div>
              <div className={styles.mainFlex}>
                <div className={styles.left}>
                  <div className={styles.key}>
                    <span className={styles.value}>Min Achieved Families:</span>
                    {data?.min_achieved_families}
                  </div>
                </div>
                <div className={styles.right}>
  <div className={styles.key}>
    <span className={styles.value}>
      Special product Incentive Rate:
    </span>
    <span className={styles.dataValue}>
      {data?.spi_payout_rate}
    </span>
  </div>
</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.tableHeader}>
  <div className={styles.left}>CATEGORY</div>
  <div className={styles.right}>FAMILY</div>
  <div className={styles.right}>SPI</div>
  <div className={styles.rate}>RATE</div>
</div>
      
        {data?.categories?.map((cat, idx) => (
          <div
            className={`${styles.flexRow} ${
              idx % 2 === 0 ? styles.rowEven : styles.rowOdd
            }`}
            key={idx}
          >
          <div className={styles.left}>
  <span className={styles.brandName}>{cat?.name}</span>
  <span className={styles.brandCode}>{cat?.code}</span>
</div>

<div className={styles.middle}>
  {cat?.is_family_incentive ? "Eligible" : "Not Eligible"}
</div>
<div className={styles.right}>
  {cat?.is_special_incentive ? "Included" : "Not Included"}
</div>
            <div className={styles.rate}>{cat?.rate}</div>
          </div>
        ))}
      </div>

      <div className={styles.plainPaper}>
        <div className={styles.heading}>Overall Incentive</div>
        <div className={styles.otherWrap}>
          <div className={styles.mainFlex}>
            <div className={styles.left}>
              <div className={styles.key}>
                <span className={styles.value}>
                  Secondary vs Primary Sales Ratio Min %:
                </span>
                {data?.secondary_vs_primary_sales_ratio_min_percent ?? "-"}
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.key}>
                <span className={styles.value}>Incentive Cap:</span>
                {data?.incentive_cap ?? "-"}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.tableHeader}>
          <div className={styles.left}>CONDITIONS</div>
          <div className={styles.right}>VALUE</div>
        </div>
        {conditionsConfig?.map((item, index) => (
          <div
            className={`${styles.flexRow} ${
              index % 2 === 0 ? styles.rowEven : styles.rowOdd
            }`}
            key={item?.key}
          >
            <div className={styles.left}>{item?.label}</div>
            <div className={styles.right}>{data?.[item?.key] || "-"}</div>
          </div>
        ))}
        <div className={`${styles.flexRow} ${styles.rowEven}`}>
          <div className={styles.left}>Call Average</div>
          <div className={styles.right}>
            {data?.doctor_call_avg ?? "-"}
            <span style={{ marginLeft: "20px" }}>
              {data?.doctor_meeting_avg ?? "-"}
            </span>
          </div>
        </div>
        <div className={`${styles.flexRow} ${styles.rowOdd}`}>
          <div className={styles.left}>Incentive withheld amount (%)</div>
          <div className={styles.right}>{data?.sales_withheld ?? "-"}</div>
        </div>
      </div>
    </div>
  );
};

export default IncentiveRules;
